import {
  TextInput,
  CheckBoxInput,
  RadioInput,
  FileInput,
} from "../components/common/ui/Inputs";
import { useEffect, useState } from "react";
import myProfileSchema from "../validation/myProfileSchema";
import { useDispatch, useSelector } from "react-redux";
import { profileAction } from "../_store/myProfile.slice";
import { userRegisterAction } from "../_store";
import formatPhoneNumber from "../_helpers/formatPhoneNumber";
import { showToastNotification } from "../components/common/ui/NotificationModal/ToastNotication";
import { Popup } from "../components/common/ui/NotificationModal/Popup";
import { history } from "../_helpers";
import MultiSelectDropdown from "../components/common/ui/Inputs/MultiSelectDropdown";
import profileIcon from "../assets/svg/AdminProfile.svg";
import Button from "../components/common/ui/Button";

function MyProfile() {
  const dispatch = useDispatch();
  const { userProfileCommitteesList } = useSelector((x) => x?.register);
  const { getProfileResponse } = useSelector((x) => x?.profile);
  const { statusOptions } = useSelector((x) => x?.dropDown);
  const ImageURL = process.env.REACT_APP_API_IMAGE_URL + "/";
  const userRoleID = Number(sessionStorage.getItem("userRoleID"));

  // State for Registration Form
  const initialProfileForm = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    committees: [],
    organization: "",
    privateMember: false,
    participateKids: 0,
    photo: "",
  };

  const [profileForm, setProfileForm] = useState(initialProfileForm);
  const [activeCommittiees, setActiveCommittiees] = useState([]);
  // const [selectedCommitteeList, setSelectedCommit] = useState([]);
  const [errorMessage, setErrorMessage] = useState({});
  const [submit, setSubmit] = useState(false);

  // Initial component mount call the committees list API
  useEffect(() => {
    dispatch(profileAction?.getMyProfile())
      .then((result) => {
        const activeCommittiee = result?.payload?.data?.user?.committees;
        setActiveCommittiees(activeCommittiee);
      })
      .catch((err) => {
        showToastNotification("Failed to get Profile data", "error");
      });
  }, [dispatch]);

  useEffect(() => {
    dispatch(userRegisterAction?.getCommitteesListforUserProfile());
  }, [dispatch]);

  useEffect(() => {
    if (getProfileResponse) {
      setProfileForm({
        firstName: getProfileResponse?.firstName || "",
        lastName: getProfileResponse?.lastName || "",
        email: getProfileResponse?.email || "",
        phoneNumber: getProfileResponse?.phoneNumber || "",
        committees: getProfileResponse?.committees || [],
        organization: getProfileResponse?.organization || "",
        privateMember: getProfileResponse?.privateMember || false,
        participateKids: getProfileResponse?.participateKids || 0,
        photo: getProfileResponse?.photo || "",
      });
    }
  }, [getProfileResponse]);

  const calculateNewCursorPosition = (oldPos, oldValue, newValue) => {
    let rawIndex = 0;
    let newIndex = 0;

    while (rawIndex < oldPos && newIndex < newValue.length) {
      if (/\d/.test(oldValue[rawIndex])) {
        while (newIndex < newValue.length && !/\d/.test(newValue[newIndex])) {
          newIndex++;
        }
        newIndex++;
      }
      rawIndex++;
    }
    return newIndex;
  };

  const handleSelectChange = (selectedOptions, fieldName) => {
    const selectedIds = selectedOptions?.map((item) => item.value) || [];
    // setSelectedCommitteeList(selectedIds);
    setProfileForm((prevForm) => ({
      ...prevForm,
      [fieldName]: selectedIds,
    }));
  };

  const handleProfileChange = (e, customName) => {
    const updatedForm = { ...profileForm };

    const target = e?.target || {};
    const name = customName || target.name;

    if (!name) return;

    let value;

    // Determine value based on input type
    if (target.type === "checkbox") {
      value = target.checked;
    } else if (target.type === "radio") {
      value = parseInt(target.value);
    } else if (target.type === "file") {
      const file = e.target.files[0];
      if (!file) return;
      updatedForm.photo = file;
      setProfileForm(updatedForm);
      return;
    } else {
      value = customName ? e?.value || "" : target.value;
    }

    // Special case: phone number formatting
    if (name === "phoneNumber") {
      const selectionStart = target.selectionStart || 0;
      const digitsOnly = value.replace(/\D/g, "");
      const formattedNumber = formatPhoneNumber(digitsOnly);

      requestAnimationFrame(() => {
        const inputElem = document.querySelector(`input[name="phoneNumber"]`);
        if (inputElem) {
          const newCursorPos = calculateNewCursorPosition(
            selectionStart,
            value,
            formattedNumber,
          );
          inputElem.setSelectionRange(newCursorPos, newCursorPos);
        }
      });

      updatedForm[name] = formattedNumber;
      setProfileForm(updatedForm);
      return;
    }

    // Email and general input character validation
    const regexMap = {
      // email: /^[a-zA-Z0-9.@_\s]*$/,
      email: /^[a-zA-Z0-9.@!#$*+-_\s]*$/,
      password: /^[\x20-\x7E]*$/, // allows all printable ASCII characters
      confirmPassword: /^[\x20-\x7E]*$/, // same as password
      firstName: /^[A-Za-z0-9 ]*$/,
      lastName: /^[A-Za-z0-9 ]*$/,
      organization: /^[A-Za-z '@_-]*$/, // same rule as firstName
      default: /^[a-zA-Z0-9\s]*$/,
    };

    const isValid =
      typeof value !== "string" ||
      (regexMap[name] || regexMap.default).test(value);

    if (!isValid) return;

    updatedForm[name] = value;
    setProfileForm(updatedForm);
  };

  const handleMyProfileSubmit = (e) => {
    e?.preventDefault();
    setErrorMessage({});
    setSubmit(true);

    const normalizedForm = {
      ...profileForm,
      Photo:
        profileForm.photo instanceof File
          ? { name: profileForm.photo.name, type: profileForm.photo.type }
          : profileForm.photo,
    };
    const userRoleID = Number(sessionStorage.getItem("userRoleID"));

    const { error } = myProfileSchema(normalizedForm, userRoleID);

    if (error?.details) {
      setSubmit(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }

    const formData = new FormData();

    // Append each field from profileForm
    for (const key in profileForm) {
      if (
        key === "photo" &&
        profileForm["photo"] !== "" &&
        profileForm.photo instanceof File
      ) {
        // Append file
        formData.append("photo", profileForm.photo);
      } else if (
        key === "committees" &&
        Array.isArray(profileForm.committees)
      ) {
        // Append each committee ID separately
        profileForm.committees.forEach((id) => {
          formData.append("committees[]", id);
        });
      } else {
        // Append other fields
        formData.append(key, profileForm[key]);
      }
    }

    // // Append each field from profileForm
    // for (const key in profileForm) {
    //   if (key === "photo" && profileForm.photo instanceof File) {
    //     formData.append("photo", profileForm.photo); // Send file
    //   } else {
    //     formData.append(key, profileForm[key]); // Send as plain value
    //   }
    // }

    //API call after validation
    dispatch(profileAction?.updateMyProfile(formData))
      .then((result) => {
        setSubmit(false);
        if (result?.payload?.status === 1) {
          // Popup({
          //   title: "Message",
          //   text: `${result?.payload?.message}`,
          //   icon: "success",
          //   confirmButtonText: "Ok",
          //   onConfirm: () => {
          //     history?.navigate("/home");
          //   },
          // });
          showToastNotification(result?.payload?.message, "success");
          dispatch(profileAction?.getMyProfile());
          setSubmit(false);
          setProfileForm(initialProfileForm);
        } else {
          Popup({
            title: "Message",
            text: `${result?.error?.message}`,
            icon: "error",
            confirmButtonText: "OK",
          });
          // showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        Popup({
          title: "Message",
          text: `Failed to create committee`,
          icon: "error",
          confirmButtonText: "OK",
        });
        // showToastNotification("Failed to create committee", "error");
        setSubmit(false);
      });
  };

  const conditionCheck = (status) => {
    if (status === 1) return false;
    var response = false;
    if (
      userProfileCommitteesList?.data?.length ===
      profileForm?.committees?.length ||
      profileForm?.committees?.length === activeCommittiees?.length ||
      activeCommittiees?.length === 1
    ) {
      response = true;
    }
    return response;
  };

  const updateMemberCommitteeList = (status) => {
    debugger;
    if (conditionCheck(status)) {
      Popup({
        title: "Message",
        text: `${"You cannot exit all committees, as this will remove your committee membership"}`,
        icon: "error",
        confirmButtonText: "OK",
      });
      return;
    }
    dispatch(
      userRegisterAction?.updateMemberCommitteeList({
        status: status,
        committees: profileForm?.committees,
      }),
    )
      .then((result) => {
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
        } else {
          showToastNotification(result?.error?.message, "error");
        }
        dispatch(profileAction?.getMyProfile())
          .then((result) => {
            const userCommitteeList = result?.payload?.data?.user?.committees;
            setActiveCommittiees(userCommitteeList);
            sessionStorage.setItem(
              "committee_Id",
              JSON.stringify(userCommitteeList),
            );
          })
          .catch((err) => {
            showToastNotification("Failed to get User Data", "error");
          });
      })
      .catch((err) => {
        showToastNotification(
          "Failed to update member committee list",
          "error",
        );
      });
  };

  const ClearProfileImage = (e) => {
    setProfileForm({ ...profileForm, photo: "" });
  };
  return (
    <section className="profile-update-section">
      <div className="container">
        <div className="profile-card">
          <div className="d-flex align-items-center gap-2">
            <h2 className="profileform-label">User Update Profile</h2>
            {/* <span
              className="un-subscribed-tag"
              title="Email Unsubscribed in CC"
            >
              Unsubscribed
            </span> */}
          </div>

          <form onSubmit={(e) => handleMyProfileSubmit(e)}>
            <div className="row gx-3 d-flex justify-content-center">
              <div className="col-md-6 mb-2 mb-md-0">
                <TextInput
                  name="firstName"
                  id="firstName"
                  placeholder="First name"
                  label="First Name"
                  handleChange={handleProfileChange}
                  required
                  value={profileForm?.firstName}
                  maxLength={25}
                  errorMessage={errorMessage}
                />
              </div>
              <div className="col-md-6">
                <TextInput
                  name="lastName"
                  id="lastName"
                  placeholder="Last name"
                  label="Last Name"
                  handleChange={handleProfileChange}
                  value={profileForm?.lastName}
                  maxLength={25}
                  errorMessage={errorMessage}
                  required
                />
              </div>
            </div>

            <div className="row gx-3 d-flex justify-content-center">
              <div className="col-md-6 mb-2 mb-md-0">
                <TextInput
                  name="email"
                  id="email"
                  placeholder="Email address"
                  label="Email"
                  ariaLabel="Email"
                  required
                  handleChange={handleProfileChange}
                  value={profileForm?.email}
                  maxLength={50}
                  errorMessage={errorMessage}
                />
              </div>
              <div className="col-md-6">
                <TextInput
                  name="phoneNumber"
                  id="phoneNumber"
                  placeholder="(000) 000-0000"
                  label="Phone Number"
                  handleChange={handleProfileChange}
                  value={profileForm?.phoneNumber}
                  // required
                  errorMessage={errorMessage}
                />
              </div>
            </div>
            {userRoleID !== 3 && (
              <>
                <div className="mb-2">
                  <MultiSelectDropdown
                    name="committees"
                    options={userProfileCommitteesList?.data}
                    displayValue="label"
                    handleChange={(e) => handleSelectChange(e, "committees")}
                    placeholder="Choose Committee"
                    required
                    label="Choose Committee"
                    ariaLabel="Choose Committee"
                    errorMessage={errorMessage}
                    selectedValue={
                      Array.isArray(userProfileCommitteesList?.data) &&
                        Array.isArray(profileForm?.committees)
                        ? userProfileCommitteesList.data.filter((option) =>
                          profileForm.committees.includes(option.value),
                        )
                        : []
                    }
                  />
                </div>

                {/* <div className="d-flex gap-2">
                  <Button
                    type="button"
                    status="green"
                    label={"Join Committee"}
                    onClick={() => {
                      updateMemberCommitteeList(1);
                    }}
                    disabled={profileForm?.committees?.length === 0}
                  />
                  <Button
                    type="button"
                    status="red"
                    label="Leave Committee"
                    onClick={() => {
                      updateMemberCommitteeList(0);
                    }}
                    disabled={profileForm?.committees?.length === 0}
                  />
                </div> */}
              </>
            )}
            <div className="mb-2">
              <RadioInput
                name="participateKids"
                id="participateKids"
                label="Are you participating in the Broward Partnerships for Kids as part of your professional reasons?"
                options={statusOptions}
                selectedValue={profileForm?.participateKids} // Get value from Redux store
                handleChange={handleProfileChange}
              />
            </div>
            {profileForm?.participateKids === 1 && (
              <div className="fs-5 text-gray">
                “If yes, then please add your organization"
              </div>
            )}
            <div className="mb-4">
              <TextInput
                name="organization"
                id="organization"
                label={"Organization"}
                placeholder={"Organization"}
                required={profileForm?.participateKids ? true : false}
                handleChange={(e) => {
                  handleProfileChange(e);
                }}
                value={profileForm?.organization}
                maxLength={256}
                // disabled={profileForm?.participateKids === 0}
                errorMessage={errorMessage}
                ariaLabel="organization"
              />
            </div>

            <div className="mb-4">
              <CheckBoxInput
                label="Private Member"
                name="privateMember"
                id={"privateMember"}
                handleClick={handleProfileChange}
                checked={profileForm?.privateMember}
              />
            </div>

            <div className="mb-3 ">
              {/* <FileInput
                name="Photo"
                label="Profile Photo"
                imageURL={
                  typeof profileForm.photo === "string"
                    ? ImageURL + profileForm.photo
                    : profileForm.photo instanceof File
                    ? URL.createObjectURL(profileForm.photo)
                    : profileIcon
                }
                // imageURL={
                //   committeeHomePage?.committeeBannerImageToShow === undefined
                //     ? ImageURL + committeeHomePage?.committeeBannerImage
                //     : committeeHomePage?.committeeBannerImageToShow
                // }
                handleFileChange={(e) => {
                  handleProfileChange(e, "photo");
                }}
                required
              /> */}

              {profileForm.photo ? (
                <FileInput
                  name="Photo"
                  label="Profile Photo"
                  imageURL={
                    typeof profileForm.photo === "string"
                      ? ImageURL + profileForm.photo
                      : profileForm.photo instanceof File
                        ? URL.createObjectURL(profileForm.photo)
                        : undefined
                  }
                  handleFileChange={(e) => handleProfileChange(e, "photo")}
                  onClearImage={(e) => ClearProfileImage(e)}
                  errorMessage={errorMessage}
                />
              ) : (
                <div className="d-flex flex-column align-items-start">
                  <FileInput
                    name="Photo"
                    label="Profile Photo"
                    handleFileChange={(e) => handleProfileChange(e, "photo")}
                  />
                  <img
                    className="ms-2 mt-2"
                    height="80"
                    width="80"
                    src={profileIcon}
                    alt="Profile"
                  />
                </div>
              )}

              {/* <label htmlFor="photo" className="form-label">
                Profile Photo
              </label> */}
              {/* <input
                type="file"
                id="photo"
                name="photo"
                accept="image/*"
                onChange={(e) => handleProfilePhotoChange(e)}
                className="form-control"
              /> */}
            </div>

            <div className="div-center">
              <button
                type="submit"
                className="sign-in-button"
                disabled={submit}
              >
                {`Update Profile`}
                {!submit ? (
                  <i className="ms-2 css-arrow-icon bi bi-arrow-right"></i>
                ) : (
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default MyProfile;
